import './style.css';
import { GameApp } from './game/GameApp';

async function bootstrap() {
  const container = document.getElementById('game-container');
  if (!container) {
    throw new Error('Game container element (#game-container) not found');
  }

  const game = new GameApp();
  await game.init(container);
}

window.addEventListener('DOMContentLoaded', () => {
  bootstrap().catch((err) => {
    console.error('Failed to start game:', err);
  });
});
